import { LoadingOverlay } from "./loading-overlay";

/**
 * Full-screen loading fallback for Suspense boundaries (e.g. lazy-loaded routes).
 * Reuses LoadingOverlay from the design system.
 */
export function PageLoader() {
  return (
    <LoadingOverlay
      fullScreen
      overlay
      size="lg"
      message="Loading..."
    />
  );
}
